import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService, NavigationService } from '@core/services';

export const loginRoutesGuard: CanActivateFn = () => {
  const navigationService = inject(NavigationService);
  const authService = inject(AuthService);

  if (authService.isAuthenticated()) {
    navigationService.navigateToAccount();
    return false;
  }
  return true;
};
